import { render, staticRenderFns } from "./R19.vue?vue&type=template&id=c2dca8e8&scoped=true"
import script from "./R19.vue?vue&type=script&lang=js"
export * from "./R19.vue?vue&type=script&lang=js"
import style0 from "./R19.vue?vue&type=style&index=0&id=c2dca8e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dca8e8",
  null
  
)

export default component.exports